import { Typography, Box } from '@mui/material';

const HeroBanner = () => {
  return (
    <Box sx={{ mt: '4rem' }}>
      <Typography variant='h2' component='h1' sx={{ fontWeight: 'bold', mb: '1rem' }}>
        The 100 Club v1.5
      </Typography>
    </Box>
  );
};

export default HeroBanner;
